import { Outlet } from 'react-router-dom'
import { Container } from '@mui/material'
import { Suspense } from 'react'
import DriverNavBar from '../../components/driverView/DriverNavBar'
import LoadingCircular from '../../components/default/LoadingCircular'

const DriverViewLayout = () => {
  return (
    <div className="App">
      <Container maxWidth={'sm'}>
        <DriverNavBar />
        <Suspense fallback={<LoadingCircular />}>
          <Outlet />
        </Suspense>
      </Container>
    </div>
  )
}

export default DriverViewLayout
